const UNDEFINED_OS = 'none';
const ANDROID_OS = 'android';
const IOS_OS = 'ios';
const MAC_OS = 'mac_os';
const WINDOWS_OS = 'windows';
const LINUX_OS = 'linux';
const WINDOWS_10_OS = 'windowsTen';

const OTHER_BROWSER = 'Windows';
const CHROME_BROWSER = 'Chrome';
const SAFARI_BROWSER = 'Safari';
const OPERA_BROWSER = 'Opera';
const FIREFOX_BROWSER = 'Firefox';
const SAMSUNG_BROWSER = 'SamsungBrowser';
const IE_BROWSER = 'IE';
const EDGE_BROWSER = 'Edge';
const EDGE_CHROMIUM_BROWSER = 'EdgeChromium';

export const getDeviceOS = () => {
  const platform = navigator.platform.toUpperCase();
  if (navigator) {
    if (/android/i.test(navigator.userAgent)) {
      return ANDROID_OS;
    }
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
      return IOS_OS;
    }
    if (/(Windows 10.0|Windows NT 10.0)/.test(navigator.userAgent)) {
      return WINDOWS_10_OS;
    }
    if (platform.indexOf('MAC') !== -1) {
      return MAC_OS;
    }
    if (platform.indexOf('WIN') !== -1) {
      return WINDOWS_OS;
    }
    if (platform.indexOf('LINUX') !== -1) {
      return LINUX_OS;
    }
  }
  return UNDEFINED_OS;
};

export const getBrowser = () => {
  const sUsrAg = navigator.userAgent;
  if (sUsrAg.indexOf('Firefox') > -1) {
    return FIREFOX_BROWSER;
    // 'Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0'
  }
  if (sUsrAg.indexOf('SamsungBrowser') > -1) {
    return SAMSUNG_BROWSER;
    // 'Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36
    // (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
  }
  if (sUsrAg.indexOf('Opera') > -1 || sUsrAg.indexOf('OPR') > -1) {
    return OPERA_BROWSER;
    // 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36
    // (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106'
  }
  if (sUsrAg.indexOf('Trident') > -1 || sUsrAg.indexOf('MSIE') > -1) {
    return IE_BROWSER;
    // 'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C;
    // .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko'
  }
  if (sUsrAg.indexOf('Edg') > -1 && sUsrAg.indexOf('Edge') === -1) {
    return EDGE_CHROMIUM_BROWSER;
    // 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36
    // (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299'
  }
  if (sUsrAg.indexOf('Edge') > -1) {
    return EDGE_BROWSER;
    // Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36
    // (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 Edge/18.18362  }
  }
  if (sUsrAg.indexOf('Chrome') > -1) {
    return CHROME_BROWSER;
    // 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36
    // (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36'
  }
  if (sUsrAg.indexOf('Safari') > -1) {
    return SAFARI_BROWSER;
    // 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X)
    // AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306'
  }
  return OTHER_BROWSER;
};

export const getValidEncodes = isLive => {
  const browser = getBrowser();
  switch (browser) {
    case CHROME_BROWSER:
    case FIREFOX_BROWSER:
      return ['dashwv_ma', 'dashwv'];
    case SAFARI_BROWSER:
      // return isLive ? ['hls_kr'] : ['hlsfps_ma', 'hlsfps', 'hls_kr', 'hls'];
      return ['hlsfps_ma', 'hlsfps', 'hls_kr', 'hls'];
    case EDGE_CHROMIUM_BROWSER: // return ['dashpr_ma', 'dashpr'];
    default:
      return ['dashwv_ma', 'dashwv'];
  }
};
